import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { useLocation } from '@/utils/location-provider';

export const JiraSoftwareFreePage = () => {
	const signupPath = useLocalizedHref('/try/cloud/signup');
	const location = useLocation();

	// ATLAS-55799 - JSW Find Team
	const queryParameters = new URLSearchParams(location.search) || {};
	const templateId = queryParameters.get('templateId') ?? '';
	const jiraProductTourSignupType = queryParameters.get('jiraProductTourSignupType') ?? '';
	const signupParameters = new URLSearchParams({
		bundle: 'jira-software',
		edition: 'free',
		skipBundles: 'true',
	});
	if (templateId) {
		signupParameters.append('templateId', templateId);
	}
	if (jiraProductTourSignupType) {
		signupParameters.append('jiraProductTourSignupType', jiraProductTourSignupType);
	}
	if (typeof window !== 'undefined') {
		window.location.assign(`${signupPath}?${signupParameters}`);
	}
	return null;
};
